// 测序合同信息管理
import {contractApi} from "@/axios";
//获取合同信息（分页）
export function getContractPage(params,data){
    return contractApi({
        url:'/sequencing-contract/page',
        method:'post',
        data:data,
        params:params
    })
}
//删除合同信息
export function deleteContract(params){
    return contractApi({
        url:'/sequencing-contract',
        method:'delete',
        params:params
    })
}
//添加合同信息
export function addContract(formData){
    return contractApi({
        url: '/sequencing-contract',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data' // 指定内容类型为 form-data
        }
    })
}
//修改合同信息
export function editContract(data){
    return contractApi({
        url:'/sequencing-contract',
        method:'put',
        data:data,
        headers: {
            'Content-Type': 'multipart/form-data' // 指定内容类型为 form-data
        }
    })
}
//合同审核
export function auditContract(data){
    return contractApi({
        url:'/sequencing-contract/audit',
        method:'put',
        data:data
    })
}
//下载附件
export function attachmentContract(id,annexType) {
    return contractApi({
        url: '/sequencing-contract/attachment/' + id + '/' + annexType,
        method: 'get',
        responseType: 'blob', // 设置响应类型为 blob
    });
}
//合同减值
export function impairmentContract(data){
    return contractApi({
        url:'/sequencing-contract/impairment',
        method:'put',
        data:data
    })
}
//转预付款
export function ContractTo(param){
    return contractApi({
        url:'/sequencing-contract/formal-to-prepayments',
        method:'put',
        params:param
    })
}
//添加合同发票邮寄
export function addContractRecordMail(data){
    return contractApi({
        url:'/sequencing-contract/add-contract-invoice-mail',
        method:'post',
        data:data,
        headers: {
            'Content-Type': 'multipart/form-data' // 指定内容类型为 form-data
        }
    })
}
//修改合同发票邮寄
export function editContractRecordMail(data){
    return contractApi({
        url:'/sequencing-contract/edit-contract-invoice-mail',
        method:'put',
        data:data,
        headers: {
            'Content-Type': 'multipart/form-data' // 指定内容类型为 form-data
        }
    })
}
//获取合同信息
export function getAllContract(contractStatus,data){
    return contractApi({
        url:'/sequencing-contract/get-all-contract' + contractStatus,
        method:'post',
        data:data
    })
}
//提交合同附件
export function submitAnnex(param,data){
    return contractApi({
        url:'/sequencing-contract/submit-annex',
        method:'put',
        params:param,
        data:data,
        headers: {
            'Content-Type': 'multipart/form-data' // 指定内容类型为 form-data
        }
    })
}
//获取合同编号
export function getContractNumber(contractType){
    return contractApi({
        url:'/sequencing-contract/get-contract-number/' + contractType,
        method:'get'
    })
}
//合同变更
export function changeContract(data){
    return contractApi({
        url:'/sequencing-contract/contract-change',
        method:'post',
        data:data,
        headers: {
            'Content-Type': 'multipart/form-data' // 指定内容类型为 form-data
        }
    })
}
//添加研发合同
export function addDevelopmentContract(data){
    return contractApi({
        url:'/sequencing-contract/add-development-contract',
        method:'post',
        data:data,
        headers: {
            'Content-Type': 'multipart/form-data' // 指定内容类型为 form-data
        }
    })
}
//合同终止
export function terminateApply(data){
    return contractApi({
        url:'/sequencing-contract/contract-terminate-apply',
        method:'put',
        data:data
    })
}
//导出合同信息
export function exportContract(data) {
    return contractApi({
        url: '/sequencing-contract/export',
        method: 'post',
        data:data,
        responseType: 'blob', // 设置响应类型为 blob
    });
}
//管理员编辑
export function adminEdit(data) {
    return contractApi({
        url: '/sequencing-contract/admin-edit',
        method: 'put',
        data:data,
        headers: {
            'Content-Type': 'multipart/form-data' // 指定内容类型为 form-data
        }
    });
}
//新增预付款转移合同
export function addTransferContract(data) {
    return contractApi({
        url: '/sequencing-contract/add-transfer-contract',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data' // 指定内容类型为 form-data
        }
    })
}
//管理员终止
export function adminTerminate(data) {
    return contractApi({
        url: '/sequencing-contract/admin-terminate',
        method: 'put',
        data: data
    })
}
//下载项目附件
export function downloadProjectAnnex(contractId, projectMainTypeId) {
    return contractApi({
        url: '/sequencing-contract/project-annex/' + contractId + '/' + projectMainTypeId,
        method: 'get',
        responseType: 'blob', // 设置响应类型为 blob
    });
}
//获取合同到款金额
export function getReceivedAmount(contractId) {
    return contractApi({
        url: '/sequencing-contract/get-received-amount/' + contractId,
        method: 'get',
    });
}
//正式合同申请预付款抵扣
export function applyPrepaymentsDeduction(data) {
    return contractApi({
        url: '/sequencing-contract/apply-prepayment-offset',
        method: 'post',
        data: data
    });
}